import React, { memo } from 'react';
import {
  IconKakao01,
  IconFacebook01,
  IconUrl01,
  IconKakao02,
  IconUrl02,
} from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  /** type */
  type?: 'kakao' | 'facebook' | 'url' | 'kakao-yellow' | 'url-gray' | undefined;
  /** onClick */
  onClick?: () => void;
}

const ShareSnsBtn = ({ type = 'url', onClick }: IProps) => {
  if (type === 'kakao') {
    return (
      <S.ShareSnsBtn
        className="share-btn"
        onClick={onClick}
        label="카카오톡"
        icon={<IconKakao01 />}
      />
    );
  }

  if (type === 'kakao-yellow') {
    return (
      <S.ShareSnsBtn2
        className="share-btn"
        onClick={onClick}
        label="카카오톡"
        icon={<IconKakao02 />}
      />
    );
  }

  if (type === 'facebook') {
    return (
      <S.ShareSnsBtn
        className="share-btn"
        onClick={onClick}
        label="페이스북"
        icon={<IconFacebook01 />}
      />
    );
  }

  if (type === 'url') {
    return (
      <S.ShareSnsBtn
        className="share-btn"
        onClick={onClick}
        label="url"
        icon={<IconUrl01 />}
      />
    );
  }

  if (type === 'url-gray') {
    return (
      <S.ShareSnsBtn2
        className="share-btn"
        onClick={onClick}
        label="url"
        icon={<IconUrl02 />}
      />
    );
  }

  return null;
};

export default memo(ShareSnsBtn);
